import { render } from "./ImportacaoRegistrosExcelModal.vue?vue&type=template&id=2b107ee6&scoped=true&ts=true"
import script from "./ImportacaoRegistrosExcelModal.vue?vue&type=script&lang=ts"
export * from "./ImportacaoRegistrosExcelModal.vue?vue&type=script&lang=ts"

import "./ImportacaoRegistrosExcelModal.vue?vue&type=style&index=0&id=2b107ee6&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b107ee6"]])

export default __exports__